export default __webpack_public_path__ + "static/banner-upgrade-your-car-with-small-loan-e85fedf7eec01619bc3b258738342427.jpg";